import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { smOfferId } from '@common/models';
import { PlatformService, UtmService } from '@common/services';
import { of } from 'rxjs';

// eslint-disable-next-line complexity
export const processQueryParams: CanActivateFn = (
    routeSnapshot: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    platformService = inject(PlatformService),
    utmService = inject(UtmService)
) => {
    if (platformService.isServer) return of(true);

    const source = routeSnapshot.queryParamMap.get('utm_source');
    const medium = routeSnapshot.queryParamMap.get('utm_medium');
    const campaign = routeSnapshot.queryParamMap.get('utm_campaign');
    const content = routeSnapshot.queryParamMap.get('utm_content');
    const term = routeSnapshot.queryParamMap.get('utm_term');

    // Successful media
    const transactionId = routeSnapshot.queryParamMap.get('transaction_id');
    const offerId = routeSnapshot.queryParamMap.get('offer_id');

    if (transactionId) {
        utmService.successfulMedia = {
            transactionId,
            offerId: offerId || smOfferId.quote.toString(),
        };
    }

    // INFO: Always set UTM, even if no params, so we get referrer with quote
    utmService.utm = {
        source,
        medium,
        campaign,
        content,
        term,
        transactionId,
        offerId,
    };

    return of(true);
};
